import { render, staticRenderFns } from "./PrivacyGuideIllegalTM.vue?vue&type=template&id=c9dde874&scoped=true"
import script from "./PrivacyGuideIllegalTM.vue?vue&type=script&lang=js"
export * from "./PrivacyGuideIllegalTM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dde874",
  null
  
)

export default component.exports